import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import classes from './BrightenChart.module.css';

function CGPieChart(props) {
	const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
	const RADIAN = Math.PI / 180;
	const sorted = [...props.data].sort((a, b) => b.qty - a.qty);
	console.log(sorted);

	const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
		const radius = innerRadius + (outerRadius - innerRadius) * 0.75;
		const x = cx + radius * Math.cos(-midAngle * RADIAN);
		const y = cy + radius * Math.sin(-midAngle * RADIAN);
		//const ta = x > cx ? 'start' : 'end';
		const pct = (percent * 100).toFixed(0);
		const label = sorted[index].label+'\n'+pct+'%'
		
		
		return (
			<text x={x} y={y} fill="white" textAnchor={"middle"} angle={0}>
				{label}
			</text>

		);
	};


	return (
		<div className={classes.pieChart}>
			<PieChart width={400} height={400}>
				<Pie
					dataKey="qty"
					isAnimationActive={false}
					data={sorted}
					outerRadius={200}
					label={renderCustomizedLabel}
					labelLine={false}
				>
					{props.data.map((entry, index) =>(
						<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
					))}

				</Pie>
				<Tooltip />
			</PieChart>
		</div>
	);
}


export default CGPieChart;